/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Due_Payments_CancelInputs */

const en_due_payments_cancel = /** @type {(inputs: Due_Payments_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancelled if unpaid`)
};

const pl_due_payments_cancel = /** @type {(inputs: Due_Payments_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nieopłacona zostanie odwołana`)
};

/**
* | output |
* | --- |
* | "cancelled if unpaid" |
*
* @param {Due_Payments_CancelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const due_payments_cancel = /** @type {((inputs?: Due_Payments_CancelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Due_Payments_CancelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_due_payments_cancel(inputs)
	return en_due_payments_cancel(inputs)
});